import { toggleSingleSceneObject } from "../../togglers/toggleSingleSceneObject";
import { OFFSET_GLIDERS } from "./pos_map";
import { updateOporaDependencies } from "./updateOporaDependencies";

export const changeOpora = (isChecked, type) => {
    const name = `stul__sta__opora__${type}`;
    const isGlaydery = type === "glaydery";

    toggleSingleSceneObject({
        allObjects: servObj.allOpora,
        activeArray: servObj.activeOpora,
        name,
        isChecked,
        position: { y: isGlaydery ? 10 - OFFSET_GLIDERS.Y : 10 },
        userData: { name, type },
    });

    // Смещаем стул по Y, если опора "Глайдеры", иначе возвращаем на 0
    servObj.redactorModeObject.children.forEach((child) => {
        child.position.y = isGlaydery ? child.position.y - OFFSET_GLIDERS.Y : 0;
    });

    // Вызываем функцию зависимостей опоры
    updateOporaDependencies();
};
